module.exports = __webpack_public_path__ + "static/media/support3.0b5a0ef7.svg";